export var OnboardingType;

(function (OnboardingType) {
  OnboardingType["none"] = "none";
  OnboardingType["megaMenu"] = "megaMenu";
  OnboardingType["megaMenuLive"] = "megaMenuLive";
  OnboardingType["slider"] = "slider";
  OnboardingType["sliderLive"] = "sliderLive";
})(OnboardingType || (OnboardingType = {}));

export var CSPOnboardingDataTestId;

(function (CSPOnboardingDataTestId) {
  CSPOnboardingDataTestId["megaMenu"] = "mega-menu-wrapper";
  CSPOnboardingDataTestId["slider"] = "csp-carousel-overaly-wrap";
})(CSPOnboardingDataTestId || (CSPOnboardingDataTestId = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/types.js
// module id = 956
// module chunks = 11